<template>
  <div class="wrap">
    <Modal
      v-model="replceSuccessModel"
      title="替换成功"
      @on-ok="confirm"
      @on-cancel="confirm"
    >
      <p>本次搜查到{{ serachCount }}个配方材料</p>
      <p>成功替换{{ successReplaceCount }}个配方材料</p>
    </Modal>
    <div class="input-wrap">
      <Form
        ref="formItem"
        :model="formItem"
        :rules="ruleValidate"
        label-position="top"
      >
        <div class="search-wrap">
          <FormItem label="搜索原材料" prop="serachMaterial">
            <Select
              v-model="formItem.serachMaterial"
              clearable
              filterable
              @on-change="getRecipeMethod"
              style="width: 200px"
            >
              <Option
                v-for="item in filteredMaterialList"
                :value="item._id"
                :key="item._id"
                >{{ item.model ? item.model : item.name }}</Option
              >
            </Select>
          </FormItem>
        </div>
        <div class="replace-wrap">
          <FormItem label="替换原材料" prop="replaceMaterial">
            <Select
              v-model="formItem.replaceMaterial"
              clearable
              filterable
              :disabled="formItem.serachMaterial ? false : true"
              @on-change="getRecipeMethod"
              style="width: 200px"
              :loading="replaceMaterialLoading"
            >
              <Option
                v-for="item in materialList"
                :value="item._id"
                :key="item._id"
                >{{ item.model ? item.model : item.name }}</Option
              >
            </Select>
          </FormItem>
        </div>
        <FormItem>
          <Button type="primary" @click="handleSubmit('formItem')">确定</Button>
        </FormItem>
      </Form>
    </div>
    <div class="recipe-wrap">
      <div class="recipe-list">
        <div
          class="recipe-item"
          v-for="item in searchRecipeList"
          :key="item._id"
        >
          <Card style="width: 320px">
            <div class="recipe-info">
              <div class="card-title">
                <h3 slot="title">{{ item.customer.name }}</h3>
              </div>
              <div class="item">
                <div>配方</div>
                <div>#{{ item.NoId }} {{ item.name }}</div>
              </div>
              <div class="item">
                <div>创建人</div>
                <div>{{ item.createdBy.name }}</div>
              </div>
              <div class="item">
                <div>审核人</div>
                <div>{{ item.verifiedBy ? item.verifiedBy.name : "" }}</div>
              </div>
              <div class="item">
                <div>状态</div>
                <div>{{ cardStatusToText(item.status) }}</div>
              </div>
              <div class="item">
                <div>创建时间</div>
                <div>{{ formatDate(item.createdAt) }}</div>
              </div>
            </div>
            <div class="item">
              <div style="text-align: left">材料</div>
              <div class="table-title">比例</div>
            </div>
            <div v-for="x in item.detail" style="">
              <!-- <div>
              {{ x.material.model ? x.material.model : x.material.name }}
            </div>
            <div>{{ (x.ratio * 100).toFixed(3) }}%</div> -->
              <MaterialRow
                :detail="x"
                :serachMaterial="formItem.serachMaterial"
              />
            </div>
          </Card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import MaterialRow from "../RawMaterialPage/MaterialRow.vue";
import dayjs from "dayjs";

const statusToText = {
  created: "未接单",
  verified: "合格",
  reviewing: "待验收",
  rejected: "不合格",
  canceled: "已取消",
};

export default {
  name: "MaterialSearchAndReplace",
  components: {
    MaterialRow,
  },
  data() {
    const validateReplace = (rule, value, callback) => {
      if (value === this.formItem.serachMaterial) {
        callback(new Error("替换材料不能与搜索材料一样"));
      } else {
        callback();
      }
    };
    return {
      replaceMaterialLoading: false,
      formItem: {
        serachMaterial: null,
        replaceMaterial: null,
      },
      ruleValidate: {
        serachMaterial: [
          { required: true, message: "请选择要搜索的材料", trigger: "blur" },
        ],
        replaceMaterial: [
          { required: true, message: "请选择要替换的材料", trigger: "blur" },
          { validator: validateReplace, trigger: "blur" },
        ],
      },
      filteredMaterialList: [],
      searchRecipeList: [],
      replceSuccessModel: false,
      serachCount: null,
      successReplaceCount: null,
    };
  },
  computed: {
    ...mapState({
      materialList: (state) => state.material.materials,
      totalRows: (state) => state.material.totalCounts,
    }),
  },
  methods: {
    ...mapActions({
      getMaterials: "material/getMaterialsAction",
      getRecipeContainMaterial: "recipeSales/getRecipeContainMaterialAction",
      bulkReplaceRecipeMaterial: "recipeSales/bulkReplaceRecipeMaterialAction",
    }),
    // getMaterialsMethod(query) {},
    // 搜索原材料
    async getRecipeMethod() {
      if (this.formItem.serachMaterial) {
        const data = await this.getRecipeContainMaterial(
          this.formItem.serachMaterial
        );
        this.searchRecipeList = data.recipeSalesList;
      } else {
        this.formItem.replaceMaterial = null;
        this.searchRecipeList = null;
      }
    },
    cardStatusToText(status) {
      return statusToText[status];
    },
    formatDate(date) {
      return dayjs(date).format("YYYY-MM-DD HH:mm");
    },
    async handleSubmit(item) {
      this.$refs[item].validate(async (valid) => {
        if (valid) {
          try {
            const data = await this.bulkReplaceRecipeMaterial({
              id: this.formItem.serachMaterial,
              changeToId: this.formItem.replaceMaterial,
            });
            this.replceSuccessModel = true;
            this.serachCount = data.n;
            this.successReplaceCount = data.nModified;
            this.$Message.success("替换成功");
          } catch (error) {
            this.$Message.error("替换失败" + error);
          }
        }
      });
    },
    confirm() {
      this.serachCount = null;
      this.successReplaceCount = null;
      this.formItem.serachMaterial = this.formItem.replaceMaterial;
      this.formItem.replaceMaterial = null;
    },
  },
  async created() {
    await this.getMaterials({ type: "raw,semi" });
    this.filteredMaterialList = this.materialList;
  },
};
</script>
<style lang="stylus" scoped>
.wrap
  display flex

.input-wrap
  padding 12px
  width 240px
  height 240px
  border 1px solid #E2E5ED
  margin-right 20px

.recipe-wrap
  border 1px solid #E2E5ED
  overflow-y scroll
  padding 15px
  flex-grow 1

.recipe-list
  display flex
  flex-wrap wrap

.recipe-wrap::-webkit-scrollbar
  display none

.recipe-item
  margin 0 25px 20px 18px

.card-title, .recipe-info
  border-bottom 1px solid #E2E5ED

.item, .card-title
  display flex
  justify-content space-between
</style>